import { render, staticRenderFns } from "./TrendDescription.vue?vue&type=template&id=1ab34911&name=trend-description&"
import script from "./TrendDescription.vue?vue&type=script&lang=js&"
export * from "./TrendDescription.vue?vue&type=script&lang=js&"
import style0 from "./TrendDescription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports